import { createSlice } from "@reduxjs/toolkit";
import { Car } from "../../../types/Car/Car.interface";
import { UserInfo } from "@/types/User/UserInfo.interface";
import { userInfoCases } from "../extra/cases/user/userInfoCases";

export interface UserState {
    userInfo: UserInfo | null;
    car: Car | null;
    isShownCarSelection: boolean;
    isShowLoginAndSignInPopup: boolean;
    selectedPickPoint: number | null;
    loading: {
        userInfo: boolean;
    };
    error: {
        userInfo: any;
    };
}

const initialState: UserState = {
    userInfo: null,
    car: null,
    isShownCarSelection: true,
    isShowLoginAndSignInPopup: false,
    selectedPickPoint: null,
    loading: {
        userInfo: false,
    },
    error: {
        userInfo: null,
    },
};

//Слайс для хранения данных пользователя
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        /** Выбор автомобиля */
        selectCar: (state, action: { payload: Car | null }) => {
            state.car = action.payload;
        },
        /** Показывать выбор автомобиля */
        setIsShownCarSelection: (state, action: { payload: boolean }) => {
            state.isShownCarSelection = action.payload;
        },
        /** Установка значения поля в userInfo */
        setUserInfoField: (state, action: { payload: {name: string, value: any} }) => {
            state.userInfo = {...state.userInfo, [action.payload.name]: action.payload.value} as UserInfo;
        },
        /** Установка значения поля индикатора показа модального окна логина и регистрации */
        setIsShowLoginAndSignInPopup: (state, action: { payload: boolean }) => {
            state.isShowLoginAndSignInPopup = action.payload;
        },
        /** Установка значения поля для пункта выдачи */
        setSelectedPickPoint: (state, action: { payload: number }) => {
            state.selectedPickPoint = action.payload;
        },
    },
    extraReducers: (builder) => {
        /** Информация о пользователе */
        userInfoCases(builder);
    },
});

export const { selectCar, setIsShownCarSelection, setUserInfoField, setIsShowLoginAndSignInPopup, setSelectedPickPoint } = userSlice.actions;

export default userSlice.reducer;